import { formatDateTimeInZone } from '@/lib/format';

const ZONE = 'Europe/Berlin';

export type FeedTimeLabel = { label: string; absolute: string };

/** Relative label in Europe/Berlin; `absolute` is the tooltip (e.g. „24.09.26, 10:07“). */
export function formatIntranetFeedTime(iso: string | null, now = new Date()): FeedTimeLabel {
  if (!iso) {
    return { label: '', absolute: '' };
  }
  const absolute = formatDateTimeInZone(iso, ZONE);
  const then = berlinDay(new Date(iso));
  const today = berlinDay(now);
  const clock = berlinClock(new Date(iso));
  const diff = today - then;
  if (diff === 0) {
    return { label: `Heute, ${clock}`, absolute };
  }
  if (diff === 1) {
    return { label: `Gestern, ${clock}`, absolute };
  }
  return { label: absolute, absolute };
}

function berlinDay(date: Date): number {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);
  const value = (type: Intl.DateTimeFormatPartTypes) =>
    Number(parts.find((part) => part.type === type)?.value ?? '0');
  return Date.UTC(value('year'), value('month') - 1, value('day')) / 86_400_000;
}

function berlinClock(date: Date): string {
  return new Intl.DateTimeFormat('de-DE', {
    timeZone: ZONE,
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).format(date);
}
